
let unknownComponent = () => m('.centrify', [
    m('i.fa.fa-file.fa-5x'),
    m('h5', 'Unknow file type')
]);


export default unknownComponent;
